'use strict';

// Thin wrapper around the site-wide Zendesk messenger (loaded via the `ze-snippet` script in index.html).
angular.module('utils').factory('OCChatWidgetUtil', function() {
  const isAvailable = () => !!window.zE;

  const sendMessengerCommand = (command) => {
    if (isAvailable()) {
      window.zE('messenger', command);
    }
  };

  return {
    open: () => {
      sendMessengerCommand('open');
    },

    hide: () => {
      sendMessengerCommand('hide');
    },

    show: () => {
      sendMessengerCommand('show');
    },
  };
});
